'use client'
import { ReactNode, useLayoutEffect } from 'react'

export default function ColorProvider({
	children,
	color = 'dark',
}: {
	children: ReactNode
	color?: 'dark' | 'light'
}) {
	const onPositionTop = () => {
		const header = document.querySelector('.header-scroll')
		if (!header) {
			return
		}

		header.classList.add("after:content-['']")
		header.classList.remove('after:content-none')
		header.classList.remove('bg-background')
		header.classList.remove('dark:bg-gray-900')
	}

	const onPositionNotTop = () => {
		const header = document.querySelector('.header-scroll')
		if (!header) {
			return
		}

		header.classList.remove("after:content-['']")
		header.classList.add('after:content-none')
		header.classList.add('bg-background')
	}

	useLayoutEffect(() => {
		const header = document.querySelector('header')
		if (!header) return

		if (color === 'light') header.classList.remove('dark')
		else header.classList.add('dark')
		// @ts-ignore
		document.activeElement.blur()

		const mobileToggleMenu = document.querySelector(
			'#dropdown-mobile-header-menu',
		)
		if (mobileToggleMenu) {
			// @ts-ignore
			mobileToggleMenu.checked = false
		}

		const { scrollTop } = document.documentElement

		if (scrollTop === 0) {
			onPositionTop()
		}

		// Sticky header bg color on scroll
		document.addEventListener('scroll', function () {
			const { scrollTop } = document.documentElement

			if (scrollTop > 0) {
				onPositionNotTop()
			} else {
				onPositionTop()
			}
		})

		if (mobileToggleMenu) {
			mobileToggleMenu.addEventListener('change', function () {
				if (this.checked) {
					document.querySelector('#search-bar').classList.add('dark')
				} else {
					document.querySelector('#search-bar').classList.remove('dark')
				}
			})
		}
	})

	return <>{children}</>
}
